import { Component, Vue } from 'vue-property-decorator'
import { Column } from 'ant-design-vue/types/table/column'
import { ShiftDetailVO, ShiftVO } from '@/service-proxies/app-v2/time.service-proxies'
import { format } from '../utils'
import { state } from '../store'
import { Reactive } from '@/utils/decorators'

@Component
export default class ModelTable extends Vue {
  @Reactive(state) currentModelDetail: ShiftVO = null

  get columns(): Partial<Column>[] {
    return [
      {
        title: this.$t('page_shift_model_shift'),
        customRender: (_, record: ShiftDetailVO) => {
          return (
            (record.indexName || `${this.$t('page_shift_model_shift')}${record.shiftIndex}`) +
            `：${format(record.shiftStartTime)} - ${format(record.shiftEndTime)}`
          )
        },
        ellipsis: true,
        width: '50%',
      },
      {
        title: this.$t('page_shift_model_rest'),
        dataIndex: 'name',
        customRender: (_, record: ShiftDetailVO) => {
          if (record.shiftRestTimeVOList) {
            return record.shiftRestTimeVOList.map(item => {
              return (
                <div>
                  {this.$t('page_shift_model_rest')}
                  {item.restIndex}：{format(item.restStartTime)} - {format(item.restEndTime)}
                </div>
              )
            })
          } else {
            return ''
          }
        },
        ellipsis: true,
        width: '50%',
      },
    ]
  }

  render() {
    return (
      <a-table
        size="small"
        columns={this.columns}
        dataSource={this.currentModelDetail.shiftDetailVOList}
        pagination={false}
        bordered
      />
    )
  }
}
